<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <b-row class="pb-3">
            <b-col>
              <h3>Pakowanie produktów</h3>
            </b-col>
            <b-col>
              <button type="button" class="btn btn-primary float-right" @click="AddPackageType">
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj pozycję
              </button>
            </b-col>
          </b-row>

          <ValidationObserver v-slot="{ invalid }" v-for="item in packageDefinitions" :key="item.id">
            <b-row>
              <b-col md="10">
                <form @submit="SaveData">
                  <b-row>
                    <b-col md="6">
                      <validation-provider rules="required" v-slot="{ errors }">
                        <small><b>Typ Receptury</b></small>
                        <v-select :disabled="!item.isEdit" :options="recipeTypes"
                                  v-model="item.recipeType" :reduce="(x) => x.value"></v-select>
                        <b-alert v-if="errors.length > 0" show variant="danger">
                          {{ errors[0] }}
                        </b-alert>
                      </validation-provider>

                    </b-col>
                    <b-col md="6">
                      <validation-provider rules="required" v-slot="{ errors }">
                        <small><b>Receptura</b></small>
                        <v-select :disabled="!item.isEdit"
                                  :options="item.recipeType == recipeType.couverture ? couverturesRecipes : coatingRecipes"
                                  label="name" v-model="item.recipeId" :reduce="(x) => x.id"></v-select>
                        <b-alert v-if="errors.length > 0" show variant="danger">
                          {{ errors[0] }}
                        </b-alert>
                      </validation-provider>
                    </b-col>

                    <b-col md="4">
                      <validation-provider rules="required|length:13" v-slot="{ errors }">
                        <small><b>EAN</b></small>
                        <input type="text" :disabled="!item.isEdit" class="form-control"
                               v-model="item.ean"/>
                        <b-alert v-if="errors.length > 0" show variant="danger">
                          {{ errors[0] }}
                        </b-alert>
                      </validation-provider>

                    </b-col>
                    <b-col md="4">
                      <validation-provider rules="required|min_value:0.001" v-slot="{ errors }">
                        <small><b>Gramatura (kg)</b></small>
                        <input type="number" step="0.001" :disabled="!item.isEdit"
                               class="form-control" v-model="item.weight"/>
                        <b-alert v-if="errors.length > 0" show variant="danger">
                          {{ errors[0] }}
                        </b-alert>
                      </validation-provider>
                    </b-col>
                    <b-col md="4">
                      <validation-provider rules="required|min_value:1" v-slot="{ errors }">
                        <small><b>Id ze sklepu</b></small>
                        <input type="number" :disabled="!item.isEdit" class="form-control"
                               v-model="item.shopId"/>
                        <b-alert v-if="errors.length > 0" show variant="danger">
                          {{ errors[0] }}
                        </b-alert>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </form>

              </b-col>
              <b-col md="2" class="div-icons-area">
                <b-button variant="outline-primary" type="submit" @click="SaveData(item)" v-if="item.isEdit"
                          :disabled="invalid" class="mr-1">
                  <i class="fas fa-check fa-lg color-green"></i>
                </b-button>
                <b-button variant="outline-primary" @click="ChangeEditStatus(item, false)"
                          v-if="item.isEdit">
                  <i class="fas fa-times fa-lg color-red"></i>
                </b-button>
                <span v-if="!item.isEdit" @click="ChangeEditStatus(item, true)" v-b-tooltip.hover
                      title="Edytuj definicję pakowania">
                                    <i class="fas fa-edit fa-lg"></i>
                                </span>
                <span v-b-tooltip.hover title="Usuń definicję pakowania" v-if="!item.isEdit"
                      @click="RemovePackageType(item)">
                                    <i class="fas fa-trash fa-lg"></i>
                                </span>
              </b-col>
              <b-col md="12">
                <hr>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";
import recipesMixins from '../../../mixins/recipes'
import packingMixin from '../../../mixins/packingMixin'
import {ValidationObserver} from 'vee-validate';

export default {
  name: "AdministrationPacking",
  components: {Loading, ValidationObserver},
  mixins: [urlConfig, toastr, recipesMixins, packingMixin],
  mounted() {
    const that = this;
    this.GetPackageDefinitions();

    this.getCoatingRecipes()
        .then((res) => that.coatingRecipes = res.data)

    this.getRecipes()
        .then((res) => that.couverturesRecipes = res.data)
  },
  data() {
    return {
      busy: false,
      isLoaded: false,
      coatingRecipes: [],
      couverturesRecipes: [],
      packageDefinitions: [],
      packageDefinitionsBeforeEdit: []
    };
  },
  methods: {
    GetPackageDefinitions() {
      const that = this;
      this.getPackingDefinitions()
          .then(function (response) {
            response.data.forEach(function (entry) {
              entry.isEdit = false;
            });
            that.packageDefinitions = response.data;
            that.isLoaded = true;
          })
          .catch(function (e) {
            console.log(e);
            var ref = that.$refs.loadingSpinner;
            ref.ShowErrorMessage(e);
            that.isLoaded = false;
          });
    },
    AddPackageType() {
      this.packageDefinitions.unshift({isEdit: true, recipeType: this.recipeType.coatingProduct});
    },

    SaveData(item) {
      if (item.id) {
        this.UpdatePackageType(item);
      } else {
        this.SaveNewPackageType(item);
      }
    },

    SaveNewPackageType(item) {
      var that = this;
      this.busy = true;

      const dataToSend = {
        recipeId: item.recipeId,
        ean: item.ean,
        typeOfRecipe: item.recipeType,
        weight: item.weight,
        shopId: item.shopId,
      }
      this.createPackingDefinition(dataToSend)
          .then(function (response) {
            if (response.data.success) {
              item.isEdit = false;
              item.id = response.data.id;
              that.DisplaySuccess(
                  "Sukces!",
                  "Nowy sposób pakowania produktów został dodany"
              );
            } else {
              that.DisplayError(
                  "Błąd!",
                  "Nie udało się zapisać nowego sposobu pakowania"
              );
            }

            that.busy = false;
          })
          .catch(function (e) {
            that.busy = false;
            console.log(e);
          });
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        this.packageDefinitionsBeforeEdit = this.packageDefinitionsBeforeEdit.filter(x => x.id !== item.id);
        this.packageDefinitionsBeforeEdit.push({...item})
      } else {
        if (!item.id) {
          this.packageDefinitions = this.packageDefinitions.filter((x) => x.id != undefined);
          return;
        }

        const packageDefBeforeChange = this.packageDefinitionsBeforeEdit.filter(x => x.id == item.id)[0];
        const editedPackageDef = this.packageDefinitions.filter(x => x.id == item.id)[0];
        editedPackageDef.ean = packageDefBeforeChange.ean;
        editedPackageDef.coatingRecipeId = packageDefBeforeChange.coatingRecipeId;
        editedPackageDef.weight = packageDefBeforeChange.weight;
        editedPackageDef.shopId = packageDefBeforeChange.shopId;
      }

      item.isEdit = status;
    },
    UpdatePackageType(item) {
      const dataToSend = {
        recipeId: item.recipeId,
        ean: item.ean,
        typeOfRecipe: item.recipeType,
        weight: item.weight,
        shopId: item.shopId,
        id: item.id ?? undefined
      }
      var that = this;
      this.busy = true;
      this.updatePackingDefinition(dataToSend)
          .then(function (response) {
            if (response.data.success) {
              that.DisplaySuccess(
                  "Sukces!",
                  "Dane zostały zaktualizowane"
              );
              item.isEdit = false;
            } else {
              that.DisplayError(
                  "Błąd!",
                  "Edycja nie powiodła się"
              );
            }
            that.busy = false;
          })
          .catch(function (e) {
            that.busy = false;
            console.log(e);
          });
    },
    RemovePackageType(item) {
      if (confirm("Czy napewno chcesz usunać sposób pakowania: ")) {
        var that = this;
        this.busy = true;
        this.deletePackingDefinition(item.id)
            .then(function () {
              that.packageDefinitions = that.packageDefinitions.filter((x) => x.id != item.id);
              that.busy = false;
            })
            .catch(function (e) {
              console.log(e);
              that.busy = false;
            });
      }
    },
  },
};
</script>